import * as React from 'react';
import initializeComponent from './react-initialize';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './chakraTheme';

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   function Initializer(props: any) {
      return (
         <ChakraProvider theme={theme}>
            <Component {...props} />
         </ChakraProvider>
      );
   }
   initializeComponent(name, Initializer, defaultProps);
}
